





























import { Component } from 'vue-property-decorator';
import Card from '@/components/dashboard/Card.vue';
import AddNewItemCard from '@/components/dashboard/AddNewItemCard.vue';
import { mapActions, mapGetters } from 'vuex';
import { EventResponse } from '@/model/Event';
import router from '@/router';
import CreateEventModal from '@/active-components/dashboard/CreateEventModal.vue';
import CustomModal from '@/components/modal/CustomModal.vue';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import ToastVariant from '@/model/enums/toast/toast-variant';
import EventsSheetsLayout from '@/components/layout/EventsSheetsLayout.vue';
import CardInnerLayout from '@/components/layout/CardInnerLayout.vue';

@Component({
    components: {
        AddNewItemCard,
        Card,
        CreateEventModal,
        CustomModal,
        EventsSheetsLayout,
        CardInnerLayout,
    },
    computed: {
        ...mapGetters({
            events: 'eventStorage/getEvents',
        }),
    },
    methods: {
        ...mapActions({
            fetchEvents: 'eventStorage/fetchEvents',
            deleteEvent: 'eventStorage/deleteEvent',
        }),
    },
})
export default class Events extends mixins(ToastMixin) {
    loading = false;

    fetchEvents!: () => Promise<void | EventResponse[]>;

    deleteEvent!: (eventId: number) => Promise<void>;

    mounted(): void {
        this.fetch();
    }

    fetch(): void {
        this.loading = true;
        this.fetchEvents().finally(() => {
            this.loading = false;
        });
    }

    onClick(id: number): void {
        router.push(`event/${id}`);
    }

    onClose(): void {
        this.$bvModal.hide('create-event-modal');
    }

    success(): void {
        this.$bvModal.hide('create-event-modal');
        this.fetch();
        this.$nextTick(() => {
            this.showToast(
                this.$t('dashboard.events.notification.successful').toString(),
                this.$t('dashboard.events.notification.title').toString(),
                ToastVariant.SUCCESS,
            );
        });
    }

    deleteEventOnClick(eventId: number): void {
        this.deleteEvent(eventId)
            .then(() => {
                this.$nextTick(() => {
                    this.showToast(
                        this.$t(
                            'dashboard.events.notification.successful-delete',
                        ).toString(),
                        this.$t(
                            'dashboard.events.notification.title',
                        ).toString(),
                        ToastVariant.SUCCESS,
                    );
                });
            })
            .catch(() => {
                this.$nextTick(() => {
                    this.showToast(
                        this.$t(
                            'dashboard.events.notification.failed-delete',
                        ).toString(),
                        this.$t(
                            'dashboard.events.notification.title',
                        ).toString(),
                        ToastVariant.DANGER,
                    );
                });
            })
            .finally(() => {
                this.$bvModal.hide(`delete-modal-${eventId}`);
            });
    }
}
